import { render, staticRenderFns } from "./loginPassPhraseIInput.vue?vue&type=template&id=0c9b6316&"
import script from "./loginPassPhraseIInput.vue?vue&type=script&lang=js&"
export * from "./loginPassPhraseIInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports